// extracted by mini-css-extract-plugin
module.exports = {"container":"ag","block":"bg","subheading":"cg","cta":"dg","disabled":"eg","noBotMargin":"fg","light":"gg"};